import React, { createContext, useContext, useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { showToast, convertISOToDateString } from '../utils/utils';
import { makeOrder, isApprove } from '../services/api';

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const { isLogged, authToken, userInfo } = useContext(AuthContext);
  const [cartItems, setCartItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [newItems, setNewItems] = useState(false);
  const [date, setDate] = useState(null);
  const [stage, setStage] = useState(0);
  const [location, setLocation] = useState(userInfo?.location);
  const [approveRequest, setApproveRequest] = useState(false);
  const [approve, setApprove] = useState(undefined);
  
  const fetchApprove = async () => {
    try {
      const token = sessionStorage.getItem('token');
      let user = JSON.parse(sessionStorage.getItem('userInfo'));
      const headers = { Authorization: "Token " + token };
      const approve = await isApprove(headers, user.id);
      return approve;
    } catch (error) {
      throw error;
    }
  };

  const updateCartItems = (updatedItems) => {
    setCartItems(updatedItems);
    // setTotalAmount(calculateTotalAmount(updatedItems));
  };

  useEffect(() => {
  }, [approve]);


  const addItem = async (product, quantity) => {
    if (stage) {
      showToast('error', 'No puedes agregar productos en esta etapa');
      return;
    }
    if (!isLogged) {
      showToast('', 'Debes ingresar para hacer pedidos');
      return;
    }
    
    if (!approveRequest) {
      let approveValue = await fetchApprove();
      setApprove(approveValue.user);
      setApproveRequest(true);
    
      let userInfo = sessionStorage.getItem('userInfo');
      userInfo = JSON.parse(userInfo);
      userInfo.approve = approveValue.user;
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));

      if (!approveValue.user) {
        showToast('', 'Necesitas verificacion para realizar pedidos');
        return;
      }
    }
    
    if (!approve && approve !== undefined) {
      showToast('', 'Necesitas verificacion para realizar pedidos');
      return;
    }

    if (quantity <= 0) return;
  
    let itemAlreadyInCart = false;
  
    const updatedCartItems = cartItems.map(item => {
      if (item.id === product.id) {
        itemAlreadyInCart = true;
        return { ...item, quantity: parseInt(quantity, 10) };
      }
      return item;
    });
  
    if (!itemAlreadyInCart) {
      updatedCartItems.push({ ...product, quantity: parseInt(quantity, 10) });
      showToast('success', 'Producto agregado');
    }
  
    updateCartItems(updatedCartItems);
    setNewItems(true);
  };  

  const removeItem = (productId) => {
    const updatedCartItems = cartItems.filter(item => item.id !== productId);
    updateCartItems(updatedCartItems);
  };

  const validateOrderDetails = () => {
    if (!isLogged) {
      showToast('', 'Debes ingresar para confirmar el pedido');
      return false;
    }

    if (!date || cartItems.length === 0) {
      showToast('error', 'Por favor completa todos los detalles del pedido');
      return false;
    }

    return true;
  };

  const confirmOrder = async () => {
    if (!validateOrderDetails()) return false;

    const orderData = {
      products: cartItems.map(product => ({
        id: product.id,
        quantity: product.quantity
      })),
      shipping_day: convertISOToDateString(date),
      shipping_address: location,
    };
    

    const headers = { Authorization: "Token " + authToken };

    try {
      await makeOrder(orderData, headers);
      setStage(0);
      setCartItems([]);
      setTotalAmount(0);
      setNewItems(false);
      setDate(null);
      showToast('success', '¡Pedido confirmado!');
      return true;
    } catch (error) {
      console.log(error);
      showToast('error', 'Error de conexión. Inténtalo de nuevo.');
      return false;
    }
  };

  return (
    <OrderContext.Provider
      value={{
        newItems, setNewItems,
        cartItems, addItem, removeItem,
        totalAmount,
        date, setDate,
        location, setLocation,
        stage, setStage,
        confirmOrder
      }}>
      {children}
    </OrderContext.Provider>
  );
};
